import { useState } from 'react';

const REJECT_REASONS = [
  'Too far away',
  'Vehicle issue',
  'Already on a delivery',
  'Personal emergency',
  'Bad weather conditions',
];

interface RejectModalProps {
  onConfirm: (reason: string) => void;
  onClose: () => void;
  loading: boolean;
}

export function RejectModal({ onConfirm, onClose, loading }: RejectModalProps) {
  const [selected, setSelected] = useState('');
  const [custom, setCustom] = useState('');

  const reason = selected === 'other' ? custom : selected;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 style={{ marginBottom: 16, fontSize: 18 }}>Reject Task</h3>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 16, fontSize: 14 }}>
          Select a reason for rejecting this task:
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {REJECT_REASONS.map((r) => (
            <button
              key={r}
              className={`btn ${selected === r ? 'btn-primary' : 'btn-outline'} btn-full`}
              style={{ fontSize: 14, minHeight: 44 }}
              onClick={() => setSelected(r)}
            >
              {r}
            </button>
          ))}
          <button
            className={`btn ${selected === 'other' ? 'btn-primary' : 'btn-outline'} btn-full`}
            style={{ fontSize: 14, minHeight: 44 }}
            onClick={() => setSelected('other')}
          >
            Other
          </button>
        </div>

        {selected === 'other' && (
          <input
            className="input"
            style={{ marginTop: 12 }}
            placeholder="Type your reason..."
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
          />
        )}

        <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
          <button className="btn btn-outline btn-full" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-danger btn-full"
            disabled={!reason || loading}
            onClick={() => onConfirm(reason)}
          >
            {loading ? 'Rejecting...' : 'Reject'}
          </button>
        </div>
      </div>
    </div>
  );
}
